import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { DiscountControlTypeDto } from "./DiscountControlTypesDto.model";
import { GeneralDiscountCatalogDto } from "./GeneralDiscountCatalogDto.model";

export class DiscountControlCheckValueDto {
    idDiscountControlCheckValues?: number;
    alphanumericValue?: string;
    numericValue?: number;
    decimalValue?: number;
    decimalStart?: number;
    decimalEnd?: number;
    dateStart?: string;
    dateEnd?: string;
    generalDiscountCatalogDto?: GeneralDiscountCatalogDto;
    discountControlTypeDto?: DiscountControlTypeDto;

    constructor(data?: Partial<DiscountControlCheckValueDto>) {
        Object.assign(this, data);
    }
}

export class DiscountControlCheckValueResponse {
    DiscountControlTypesDto: DiscountControlCheckValueDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class DiscountControlCheckValueRequest {
    DiscountControlTypesDto: DiscountControlCheckValueDto = new DiscountControlCheckValueDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}